<script>
    import HomeSportSearch from './HomeSportSearch';
    import HomeCarousel from './HomeCarousel';
    import HomeCourseCard from './HomeCourseCard';
    import HowOrangoWorksBreadcrumb from './HowOrangoWorksBreadcrumb';

    export default {
        name: "Homepage",
        components: {
            HomeSportSearch,
            HomeCarousel,
            HomeCourseCard,
            HowOrangoWorksBreadcrumb
        },
        props: {
            courses: {}
        },
        data() {
            return {
                latitude: 0,
                longitude: 0,
                geoerrormessage: null,
                showGeoActivities: true,
                showGeoEvents: true,
                sports: [
                    {url: 'https://picsum.photos/600/300/?image=25'},
                    {url: 'https://picsum.photos/600/300/?image=26'},
                    {url: 'https://picsum.photos/600/300/?image=27'},
                    {url: 'https://picsum.photos/600/300/?image=28'},
                    {url: 'https://picsum.photos/600/300/?image=29'}
                ],
                courses_by_distance: [],
                events_by_distance: [],
                mobileDetect: window.innerWidth < 1000,
            }
        },
        mounted() {
            const self = this;

            this.$bus.$on('geolocalizated', function (args) {
                self.geoerrormessage = null

                self.latitude = args.latitude
                self.longitude = args.longitude

                axios({
                    method: 'get',
                    url: `/courses_by_distance?latitude=${args.latitude}&longitude=${args.longitude}`,
                }).then((response) => {
                    self.courses_by_distance = response.data
                    if (self.courses_by_distance.length) {
                        $('#close_courses').removeClass('hidden')
                    }
                }).catch((error) => {
                    this.message = 'Error'
                });

                axios({
                    method: 'get',
                    url: `/events_by_distance?latitude=${args.latitude}&longitude=${args.longitude}`,
                }).then((response) => {
                    if (response.data.results.data && response.data.results.data.length > 0) {
                        self.events_by_distance = response.data.results.data   
                    } else {
                        this.showGeoEvents = false
                    }
                }).catch((error) => {
                    this.message = 'Error';
                })
            })

            this.$bus.$on('geoerror', function() {
                self.geoerrormessage = 'Attenzione: occore attivare la geolocalizzazione per poter effettuare la ricerca dei corsi e degli eventi vicino a te!'
            })

            const $list = $("#home-main-list")

            const $li1 = $list.find("li").eq(0)
            const $li2 = $list.find("li").eq(1)
            const $li3 = $list.find("li").eq(2)
            const $li4 = $list.find("li").eq(3)

            const date = new Date()
            const month = date.getMonth() + 1
            const day = date.getDate()

            // ce first
            let reverse = !((month === 3 && day >= 15) || (month >= 4 && month <= 8) || (month === 9 && day <= 15))

            if (reverse) {
                $li2.insertBefore($li1)
            }

            $li3.remove()
            $li4.remove()
            
            $li1.show()
            $li2.show()

            window.onresize = () => {
              console.log(window.innerWidth)
              this.$set(this, 'mobileDetect', window.innerWidth < 1000)
            }
        },
        methods: {
            onShowEvent(event) {
                location.href = route('event.show', event.slug)
            },
            /*triggerSpinner() {
                $('#spinner-modal').modal();
            },
            shutdownSpinner() {
                $('#spinner-modal').modal('hide');
            },*/
        },
        computed: {
            courseList() {
                if (!this.courses) {
                    return []
                }
                return this.courses;
            },
            orderedCourseList() {
                if (this.courses_by_distance.length > 0) {
                    this.showGeoActivities = true
                    return this.courses_by_distance
                } else {
                    this.showGeoActivities = false
                    return []
                }
            }
        }
    }
</script>

<style scoped>
.home-page .event-vertical-card-container {
    margin: 1rem 5px 10px!important;
    border-radius: 0;
}
.event-vertical-card-container__cover-image-container {
    -webkit-box-shadow: 0px -4px 8px rgba(156, 156, 156, 0.33);
    box-shadow: 0px -4px 8px rgba(156, 156, 156, 0.33);
    border-radius: 5px 5px 0 0;
    border-top: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
    border-bottom: none !important;
    border-left: 1px solid #ddd !important;
}

.event-vertical-card-container__body {
    -webkit-box-shadow: 0px 4px 8px rgba(156, 156, 156, 0.33);
    box-shadow: 0px 4px 8px rgba(156, 156, 156, 0.33);
    border-top: none !important;
    border-right: 1px solid #ddd !important;
    border-bottom: 1px solid #ddd !important;
    border-left: 1px solid #ddd !important;
}

.event-vertical-card-container__cover-image-container .sport-tag {
    font-size:12px;
    padding: 2px 10px;
    bottom:16px;
}
.event-vertical-card-container__cover-image-container .date-small-container {
    left:10px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/home/Homepage.vue